var _a, _b;
import React from 'react';
import { SpecialistSelectView } from './View';
import { mockSpecialistResponse } from '../../../../../../../context/mockData/data';
var injectors = (_b = (_a = mockSpecialistResponse === null || mockSpecialistResponse === void 0 ? void 0 : mockSpecialistResponse.data) === null || _a === void 0 ? void 0 : _a.getInjectors) === null || _b === void 0 ? void 0 : _b.injectors;
export var SpecialistSelectContainer = function (_a) {
    var initialVal = _a.initialVal, onSelect = _a.onSelect, handleRestart = _a.handleRestart;
    return (React.createElement(SpecialistSelectView, { handleRestart: handleRestart, initialVal: initialVal, onSelect: onSelect, injectors: injectors, loading: false }));
};
